export const GET_DOCUMENT_TEMPLATE_FIELDS = gql`
  query GET_DOCUMENT_TEMPLATE_FIELDS($documentTemplateId: String!) {
    documentTemplateFields(documentTemplateId: $documentTemplateId) {
      documentTemplateFieldId
      fieldLabel
      fieldName
      fieldType
      signers
      isRequired
    }
  }
`

export const UPDATE_DOCUMENT_TEMPLATE_FIELD = gql`
  mutation UPDATE_DOCUMENT_TEMPLATE_FIELD($documentTemplateFieldId: String!, $input: UpdateDocumentTemplateFieldInput!) {
    updateDocumentField(documentTemplateFieldId: $documentTemplateFieldId, input: $input) {
      documentTemplateFieldId
      fieldLabel
      fieldName
      fieldType
      signers
      isRequired
    }
  }
`

export const REFRESH_DOCUMENT_TEMPLATE_FIELDS = gql`
  mutation REFRESH_DOCUMENT_TEMPLATE_FIELDS($documentTemplateFieldId: String!) {
    refreshDocumentFields(documentTemplateFieldId: $documentTemplateFieldId) {
      documentTemplateFieldId
      fieldLabel
      fieldName
      fieldType
      signers
      isRequired
    }
  }
`
